module.exports = __webpack_public_path__ + "img/12.1c89af03.png";